import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, token } = useSelector((state: RootState) => state.auth);
  const hasValidAuth = isAuthenticated && token && localStorage.getItem('token');
  
  return hasValidAuth ? <>{children}</> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;